import FastModal from 'components/FastModal';
import ElementPrefixId from 'constants/elementPrefixId';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {hideTypedModal} from 'stores/actions/typedModalAction';
import style from './ModalServiceError.module.scss';

function ModalCannotUseThisFeature() {
  const dispatch = useDispatch();
  const {formatMessage} = useIntl();

  const content = (
    <div id={`${ElementPrefixId.MODAL_CANNOT_USE_THIS_FEATURE}-container`} className={style.container}>
      <span className={style.description}>
        {formatMessage({id: 'modal.cannotUseThisFeature.text.restartInstrument'})}
      </span>
    </div>
  );

  const handleClickClose = () => {
    dispatch(hideTypedModal());
  };

  const buttons = [
    {
      className: 'btn-lg',
      style: 'primary',
      text: formatMessage({id: 'modal.cannotUseThisFeature.button'}),
      handlerClick: handleClickClose,
    },
  ];

  return (
    <FastModal
      show
      header={formatMessage({id: 'modal.cannotUseThisFeature.title'})}
      content={content}
      btnAction={buttons}
      size="md"
      closeDisabled={false}
      onClose={handleClickClose}
    />
  );
}

export default ModalCannotUseThisFeature;
